export class AgeRange {
    public ageRangeId: number;
    public description: string;
    public ageApplied: number;
    public order: number;
}